import PropTypes from "prop-types";

import T from "../../translations/Translations";

import "../../../styles/DcsdModalStyling.scss";

const InformationIncorrectListForm = ({ formState }) => {
    return (
        <div className="outer-container">
            <div className="heading">
                {T({ key: "OE_Dialog_Incorrect_Info_Body_1" })}
                <u>
                    <strong>
                        {" "}
                        {formState?.firstName} {formState?.lastName}
                    </strong>
                </u>
            </div>
            <div className="instructions-container">{T({ key: "OE_Dialog_Incorrect_Info_Body_2" })}</div>
        </div>
    );
};

InformationIncorrectListForm.propTypes = {
    formState: PropTypes.oneOfType([PropTypes.object])
};

InformationIncorrectListForm.defaultProps = {
    formState: null
};

export default InformationIncorrectListForm;
